import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit {

  @Input('isShow') isShow: boolean;

  constructor() { }

  ngOnInit() {
  }

}
